module.exports = __webpack_public_path__ + "static/img/recommend_product_mini2.cf1deb37.png";